// extracted by mini-css-extract-plugin
export default {"lastUpdated":"finance-blocks_last-updated_lastUpdated","disclaimer":"finance-blocks_last-updated_disclaimer"};